// import { Tick } from 'chart.js';
import React, { useCallback, useEffect, useState } from 'react'
import * as XLSX from 'xlsx';
// import { Line } from 'react-chartjs-2';
// import Select from 'react-select';
import Select, { components } from "react-select";
import dataExcel from '../../jsons/figuras-publicas.json'
// import exportFromJSON from 'export-from-json';
// import jsonColor from "../../jsons/colores.json"
import LineChart from '../../Components/highChart/BubbleChart'
import {listaColoresChart} from '../../Components/shared/colores';

type listItemT = {
  label: string,
  value: string,
  isFixed: boolean
}

const defaultData = {
  label: '',
  data: [],
  borderColor: '',
  fill: false,
  tension: 0.4,
};

const customStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      padding: 4,
      fontSize: 12,

    }),
    multiValue: (base: any, state: any) => {
      return { ...base, fontSize: 14 };
    },
    // control: () => ({
    //   // none of react-select's styles are passed to <Control />
    //   width: 200,
    // }),
    singleValue: (provided: any, state: any) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';


      return { ...provided, opacity, transition };
    }
  }

const ChartV5 = (props?:{piePagina?:string}) => {
  const nameTitle = "NombreP";

  const [valuesSelected, setValuesSelected] = useState([]);
  //----
  const [currentDataSetDefault, setCurrentDataSetDefault] = useState([]);

  const [currentDatasetItem, setCurrentDatasetItem] = useState([defaultData]);

  const [arrayColores, setArrayColores] = useState(listaColoresChart);

  const [valueLabels, setValueLabels] = useState<String[]>([]);

  const [saveValuesCount, setSaveValuesCount] = useState(2);

  function getItemsToAddList(): listItemT[] {
    let selectAux : any = []
    dataExcel.Hoja1.map((item: any) => {
      if ( item[nameTitle] === 'punto de corte'){
        selectAux.push({ label: item[nameTitle], value: item[nameTitle], isFixed: true });
      } else{
        selectAux.push({ label: item[nameTitle], value: item[nameTitle], isFixed: false });
      }
      // ({ label: item[nameTitle], value: item[nameTitle], isFixed: false }))
    });
    
    // return dataExcel.Hoja1.map((item: any) => ({ label: item[nameTitle], value: item[nameTitle], isFixed: false }));
    return selectAux;
  }

  const uploadDefaultData = async (items: any) => {
    console.log('Se activo el Defaultdata');

    // clg("ITEM :: ", items);
    if (currentDataSetDefault.length > 0) {
      setCurrentDataSetDefault([]) // set default en 0
    }

    const values = items.map((item: any) => item.value);

    setValuesSelected(items);
    if (items.length === 0) {
      setCurrentDatasetItem([]);
      return defaultData;
    }

    const updatedItemsDataset: any = [];
    const dataSet = await arrayDataset();
    let datasetItem = [];
    values.forEach((val: any) => {
      datasetItem = dataSet.find((item: any) => item.name === val);
      if (datasetItem) {
        updatedItemsDataset.push(datasetItem);

      }
    });
    setCurrentDatasetItem(updatedItemsDataset);
  }

  const onChangeSelect = async (items: any) => {
    console.log("ITEM :: ", items);
    // setCurrentDataSetDefault([]) // set default en 0

    const values = items.map((item: any) => item.value);

    if (values.length > saveValuesCount && values.length >= 10) {
      setSaveValuesCount( saveValuesCount + 1);
      setArrayColores([
          ...arrayColores,
          `rgb(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)})`
          ]
      );
  }
    // console.log(items)
    setValuesSelected(items);
    if (items.length === 0) {
      setCurrentDatasetItem([]);
      return defaultData;
    }

    const updatedItemsDataset: any = [];
    const dataSet = await arrayDataset();
    let datasetItem = [];
    values.forEach((val: any) => {
      datasetItem = dataSet.find((item: any) => item.name === val);
      if (datasetItem) {
        updatedItemsDataset.push(datasetItem);
      }
    });
    setCurrentDatasetItem(updatedItemsDataset);
    // const updatedItemsDataset: any = [];
    // values.forEach((val: any) => {
    //   let datasetItem = currentDataSet.find((item: any) => item.name === val);
    //   if (datasetItem) {
    //     updatedItemsDataset.push(datasetItem);
    //   }
    // });
    // setCurrentDatasetItem(updatedItemsDataset);
  }

  const setDataGrafico = (data: any) => {
    let arrayAux: any = [];
    data.map((item: any) => {
      let objAux: any = {};
      // delete item.created_on;
      // delete item.id;
      for (const key in item) {
        if (key.toString() === "NombreP") {
          objAux['nombre'] = item[key];

        }
      }
      for (const key in item) {
        if (key.toString() !== "NombreP") {
          objAux["- " + key.toString() + " -"] = item[key.toString()] ? item[key.toString()] : '-';
        }
      }
      arrayAux.push(objAux);
    })
    const updatedItemsDataset: any = [];
    valuesSelected.forEach((valor: any) => {
      let datasetItem = arrayAux.find((item: any) => item.nombre === valor.value);
      if (datasetItem) {
        updatedItemsDataset.push(datasetItem);
      }
    })
    return updatedItemsDataset;
  }

  const exportExcel = (params: any) => {


    //Creo un nuevo excel
    const wb = XLSX.utils.book_new();

    //Se setean los datos al formato para el excel
    const data = XLSX.utils.json_to_sheet(setDataGrafico(dataExcel.Hoja1));

    //Se crea una pagina por cada cada grafico con sus respectivos datos
    XLSX.utils.book_append_sheet(wb, data, 'Figura-Publica');

    //Se descarga el excel
    XLSX.writeFile(wb, "Data " + "Figura-Publica" + ".xlsx")
  }


  const settingData: any = (data: any) => {
    if (data) {
      let response: any = {
        name: '',
        data: []
      };
      let iKey = 0
      let obj :any = {
        x: 0,
        y: 0,
        z: 0,
        name: ''
    }
      for (const key in data) {
        let value: any = data[key];
        if (key == "NombreP") {
          response.name = value;
          let cadena:any='';
          value.split(' ').map((texto:any) => cadena += texto.slice(0, 1));
          obj.name = cadena;
        } else {
          if (value != "-") {
            const keyLabel = key.replace('Conocimiento (X)', 'x').replace('Imagen Positiva (Y)', 'y').replace('Imagen Positiva (Z)', 'z')
                        // console.log(keyLabel)
                        obj[keyLabel] = parseInt(data[key]);
          }
          iKey++;
          // else {
          // response.data.push([key, 0]);
          // }
        }
      }
      response.data.push(obj)
      console.log('RESPONSE - RESPONSE - RESPONSE - RESPONSE');
      console.log(response);
      return response;
    } else {
      return 'No Data'
    }
  }

  const arrayDataset = async () => {
    // console.log("Acá")
    let arrayItem: any = [];
    await dataExcel.Hoja1.reduce(async (waitExcel, dataItem) => {
      await waitExcel;
      // console.log(`VALUE ::: ${arrayItem}`)
      const dataFormat = await settingData(dataItem);
      // console.log(`FORMAT ::: ${arrayItem}`)
      arrayItem.push(dataFormat);
    }, Promise.resolve());

    return arrayItem;
    // setCurrentDataSet(arrayItem);
  }

  const getLabels = async () => {
    let arrayAux: any = [],
      arrayAux2: any = [];
    let arrayDefaultData: any = [];

    dataExcel.Hoja1.forEach((dataItem: any) => {
      //console.log(dataItem);
      if (valuesSelected.length > 0) {
        valuesSelected.map((item: any) => {
          if (item.value == dataItem[nameTitle]) {
            arrayAux.push(dataItem);
          }
        });
      } else {
        // Solo dejemos Cadem apruebo y Cadem rechazo.
        // if (dataItem["NombreP"] == "Michelle Bachelet" || dataItem["NombreP"] == "Cristián Warnken" ) {
        if (dataItem["NombreP"] == "punto de corte" ) {
          arrayDefaultData.push({ label: dataItem["NombreP"], value: dataItem["NombreP"] })
        }
        arrayAux.push(dataItem);
      }
    });

    setCurrentDataSetDefault(arrayDefaultData); // Labels por default
    // console.log(arrayAux)
    // console.log(arrayAux);
    arrayAux.map((item: any) => {
      for (const key in item) {
        if (key !== nameTitle) {
          arrayAux2.push(key);
        }
      }
    })

    const uwu: any = new Set(arrayAux2);
    return [...uwu]
  }

  useEffect(() => {
    // let array: any = [];
    // let arrayDefaultData: any = [];

    // dataExcel.Hoja1.map((dataItem: any) => {
    //   if(dataItem["Apruebo/Rechazo"] == "Promedio mensual apruebo" || dataItem["Apruebo/Rechazo"] == "Promedio mensual rechazo"){
    //     arrayDefaultData.push(settingData(dataItem))
    //   }
    //   array.push(settingData(dataItem));
    // })



    const fetchData = async () => {
      const data = await arrayDataset();
      // console.log("acá 1")
      return data
    }

    // call the function
    fetchData()
      .then(data => console.log(data))
      .catch(console.error);

    const fetchLabels = async () => {
      const data = await getLabels();
      return data;
    }
    fetchLabels()
      .then(data => setValueLabels(data))
      .catch(console.error);

    // const labels = await getLabels()
    // setCurrentDataSet(array);
    // setCurrentDatasetItem(arrayDefaultData);

    // let valoresDefault: any = [
    //   {
    //     "label": "Michelle Bachelet",
    //     "value": "Michelle Bachelet"
    //   },
    //   {
    //     "label": "Cristián Warnken",
    //     "value": "Cristián Warnken"
    //   }
    // ];
    let valoresDefault: any = [
        {
          "label": "punto de corte",
          "value": "punto de corte"
        },
        {
          "label": "E. Matthei",
          "value": "E. Matthei"
        },
        {
          "label": "R. Carter",
          "value": "R. Carter"
        },
        {
          "label":"M. Bachelet",
          "value":"M. Bachelet"
        },
        {
          "label": "C. Orrego",
          "value": "C. Orrego"
        }
      ];
    uploadDefaultData(valoresDefault);

  }, [])


  const MultiValueRemove = (props : any) => {
    if (props.data.isFixed) {
      return null;
    }
    return <components.MultiValueRemove {...props} />;
  };


  return (
    <div className="shadow p-3 mb-5 bg-body rounded chart-content">
      <Select
        isMulti
        styles={customStyles}
        placeholder="Seleccionar..."
        closeMenuOnSelect={true}
        options={getItemsToAddList()}
        onChange={onChangeSelect}
        isClearable={false}
        isSearchable={true}
        backspaceRemovesValue={true}
        // defaultValue={[colourOptions[0], colourOptions[1]]}
        defaultValue={[{
          "label": "punto de corte",
          "value": "punto de corte", 
          "isFixed" : true
        },{
          "label": "E. Matthei",
          "value": "E. Matthei"
      },{
          "label": "R. Carter",
          "value": "R. Carter"
      },{
        "label":"M. Bachelet",
        "value":"M. Bachelet"
      },{
        "label": "C. Orrego",
        "value": "C. Orrego"
      }
      ]}
        components={{ MultiValueRemove }}
        // defaultValue={[{
        //   "label": "Michelle Bachelet",
        //   "value": "Michelle Bachelet"
        // },{
        //   "label": "Cristián Warnken",
        //   "value": "Cristián Warnken"
        // }]}
      />
      <div className='mt-3'>

        <LineChart
          allData={currentDatasetItem}
          title="Conocimiento e imagen de figuras políticas. Marzo 2023"
          labels={valueLabels}
          exportExcel={exportExcel}
          colores={arrayColores}
          activeButton={valuesSelected.length > 0 ? true : false}
          dataDefault={currentDataSetDefault}
          onChangeSelect={onChangeSelect}
        />
        <div className='d-flex flex-row-reverse mt-4' >

          <p style={{ fontSize: 12 }}>{props?.piePagina?props.piePagina:''}</p>
        </div>
      </div>
    </div>
  )
}

export default ChartV5;
